import { createStyles } from '@affstore-ds/uikit'

export const useTransferLoaderStyles = createStyles(() => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
  loader: {
    width: 48,
    height: 48,
  },
}))
